import { Injectable, OnDestroy } from '@angular/core';
import { from, Observable, Subscription } from 'rxjs';
import { filter, tap, toArray } from 'rxjs/operators';
import { StorageKey, StorageService } from '@dta/shared/services/storage/storage.service';
import { AutoUnsubscribe } from '@dta/shared/utils/subscriptions/auto-unsubscribe';

@AutoUnsubscribe()
@Injectable()
export class FlushDatabaseService implements OnDestroy {
  //////////////////
  // Subscriptions
  //////////////////
  protected cleanLocalStorageSub: Subscription;

  constructor(protected _storageService: StorageService) {}

  ngOnDestroy(): void {}

  init() {}

  changeAPI(data) {
    if (!data || !data.environment) {
      return;
    }

    this.flushDb();
  }

  flushDb() {
    localStorage.clear();

    this.afterCleanLocalStorage();
  }

  redoInitSync(showPopup: boolean = true, reload: boolean = false) {
    if (showPopup) {
      localStorage.setItem(StorageKey.redoInitSyncRequired, 'true');
    }

    this.cleanLocalStorageSub?.unsubscribe();
    this.cleanLocalStorageSub = this.cleanLocalStorage()
      .pipe(
        tap(() => {
          this.afterCleanLocalStorage(reload);
        })
      )
      .subscribe();
  }

  protected afterCleanLocalStorage(reload: boolean = false) {
    // Do nothing by default
    if (reload) {
      location.reload();
    }
  }

  private cleanLocalStorage(): Observable<any> {
    return from(Object.keys(localStorage)).pipe(
      filter(key => {
        return (
          false ||
          // Pull sync parameters
          key.includes(StorageKey.activeSyncHistoryId) ||
          key.includes(StorageKey.activeConversationSyncHistoryId) ||
          // User properties
          key.includes(StorageKey.userEmailSettings) ||
          // Other
          key.includes('unread') ||
          // we should not be clearing app preferences
          (key.includes('preferences') && key !== 'app_preferences') ||
          key.includes(StorageKey.avatarIdSync) ||
          key.includes(StorageKey.activated) ||
          key.includes(StorageKey.lastCompletedPurgeAt)
        );
      }),
      tap(key => {
        localStorage.removeItem(key);
      }),
      toArray()
    );
  }
}
